import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import incomeTransactionsHeaders from "@/pages/Accounting/IncomeTransactions/incomeTransactionsHeaders";
import paymentTransactionsHeaders from "@/pages/Accounting/IncomeTransactions/paymentTransactionsHeaders";

export default {
	state: {
		incomeTransactionsItem: null,
		incomeTransactionsId: null,
		incomeTransactionsFilters: null,
		incomeTransactionsList: null,
		incomeTransactionsLimit: null,
		incomeTransactionsOrder: null,
		incomeTransactionsSort: null,
		incomeTransactionsTotal: null,
		incomeTransactionsUpdate: null,
		incomeTransactionsTotals: null,

		contract: [],
		filterContract: {},
		deleteIncomeTransactionsFilesList: [],
		deleteContractsList: [],

		incomeTransactionsLogs: [],
		incomeTransactionsLogsFilter: {},

		incomeTransactionsCustomers: [],
		incomeTransactionsRow: {},

		paidTransactionsData: null,

	},
	mutations: {

		updatePaidTransactionsData(state, payload) {
			state.paidTransactionsData = payload || null;
		},

		updateIncomeTransactionsList(state, { loads, limit, order, sort, total, update, sum }) {
			const normalizedLoads = (loads || []).map((item) => {
				const isZelle = String(item.name || '').toLowerCase() === 'zelle';

				if (!isZelle || !item.original_description) {
					return item;
				}

				return {
					...item,
					original_description: item.original_description
						.trim()
						.replace(/\s+\S+$/, ''),
				};
			});

			state.incomeTransactionsList = normalizedLoads;
			state.incomeTransactionsLimit = limit;
			state.incomeTransactionsOrder = order;
			state.incomeTransactionsSort = sort;
			state.incomeTransactionsTotal = total;
			state.incomeTransactionsUpdate = update;
			state.incomeTransactionsTotals = { id: total, amount: sum.sum_amount };
		},

		updateIncomeTransactionsFilters(state, { filter }) {
			console.log('%c [  filter  ] ', 'color:#bada55', typeof filter, filter );
			state.incomeTransactionsFilters = filter || {};
		},
		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},

		updateLogs(state, payload) {
			state.incomeTransactionsLogs = payload?.logs || [];
			state.incomeTransactionsLogsFilter = payload?.logsFilter || {};
		},
		updateEditIncomeTransactions(state, payload) {
			state.incomeTransactionsCustomers = payload?.customers || [];
			state.incomeTransactionsRow = payload?.row || {};
		},
	},
	actions: {

		async getIncomeTransactionsCastomer({ commit, dispatch }, { id, filters }) {

			dispatch("actionPreloader", true);
			try {

				const { data } = await httpClient.post(`income-transactions/list/${ id }`, filters);

				if (data && !data.status) {
					commit('updateIncomeTransactionsList', data);
					commit('updateSettings', {
						settings: data.settings,
						key: requestKeys.TRUCKS,
						defaultHeader: paymentTransactionsHeaders
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getIncomeTransactionsCastomerFilters({ commit }, { id, values }) {
			try {
				const { data } = await httpClient.post(`income-transactions/filters/${ id }`, values);
				console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );
				if (data) commit('updateIncomeTransactionsFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getIncomeTransactions({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {

				const { data } = await httpClient.post('/income-transactions/list', filters);

				if (data && !data.status) {
					commit('updateIncomeTransactionsList', data);
					commit('updateSettings', {
						settings: data.settings,
						key: requestKeys.TRUCKS,
						defaultHeader: incomeTransactionsHeaders
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getIncomeTransactionsFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/income-transactions/filters', values);
				console.log('%c [  data  ] ', 'color:#bada55', typeof data, data );
				if (data) commit('updateIncomeTransactionsFilters', data);
			} catch (e) {
				console.error(e);
			}
		},
		async getRefresh({ commit }) {
			try {
				const { data } = await httpClient.get('/income-transactions/refresh');

				if (data) {
					commit('updateLogs', data);
				}

				return data;
			} catch (e) {
				console.error(e);
				throw e;
			}
		},
		async getPaidTransactionsData({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/income-transactions/create-pay/${ id }` );

				if (data) {
					commit('updatePaidTransactionsData', data);
				}

				return data;
			} catch (e) {
				console.error(e);
				throw e;
			}
		},

		/**
		 * Saves paid transaction.
		 *
		 * @param {Object} context Vuex context.
		 * @param {Function} context.dispatch Vuex dispatch.
		 * @param {Object} values Payment values.
		 * @returns {Promise<Boolean>} Saving status.
		 */
		async onPaidTransactions({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('/income-transactions/paid', values );

				if (data && data.status) {
					dispatch('setAlert', {
						type: 'success',
						message: 'Invoice paid successfully'
					});

					return true;
				}

				dispatch('setAlert', {
					type: 'error',
					message: 'Payment error'
				});

				return false;
			} catch (e) {
				console.error(e);

				dispatch('setAlert', {
					type: 'error',
					message: 'Payment error'
				});

				return false;
			}
		},

		async getFilterLogs({ commit }, values) {
			try {
				const { data } = await httpClient.post('/income-transactions/filterLogs', values);
				if (data) commit('updateLogs', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onIncomeTransactionsRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/incomeTransactions/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getCustomerInfoForDriver({ dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/customers/${ value }`);
				if (data && !data.status) {
					return data;
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onEditIncomeTransactions({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/income-transactions/${ id }/edit`);
				if (data) commit('updateEditIncomeTransactions', data);
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onUpdateIncomeTransactions({ dispatch }, values) {
			const { id, ...obj } = values;

			try {
				const { data } = await httpClient.put(`/income-transactions/${ id }`, obj );

				if (!data) {
					return false;
				}

				if (data.status) {
					dispatch("setAlert", {
						type: "success",
						message: "Customer updated successfully"
					});

					return true;
				}

				dispatch("setAlert", {
					type: "error",
					message: "Saving error"
				});

				return false;
			} catch (e) {
				console.error(e);

				dispatch("setAlert", {
					type: "error",
					message: "Saving error"
				});

				return false;
			}
		},

		async onDriverDeleteFiles({ state }) {
			if (state.deleteIncomeTransactionsFilesList.length) await httpClient.post(`/incomeTransactions/destroyFiles`, { ids: state.deleteIncomeTransactionsFilesList });
		},

		async onContractDelete({ state }) {
			if (state.deleteContractsList.length) await httpClient.post(`/incomeTransactions/destroyContract`, { ids: state.deleteContractsList });
		},

		getContractDelete({ commit }, { id, isDelete }) {
			commit('updateContractDelete', { id, isDelete });
		},

		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},

	},
	getters: {
		incomeTransactionsItem: (s) => s.incomeTransactionsItem,
		incomeTransactionsList: (s) => s.incomeTransactionsList,
		incomeTransactionsFilters: (s) => s.incomeTransactionsFilters,
		incomeTransactionsTotals: (s) => s.incomeTransactionsTotals,
		incomeTransactionsLimit: (s) => s.incomeTransactionsLimit,
		incomeTransactionsOrder: (s) => s.incomeTransactionsOrder,
		incomeTransactionsSort: (s) => s.incomeTransactionsSort,
		incomeTransactionsUpdate: (s) => s.incomeTransactionsUpdate,
		incomeTransactionsTotal: (s) => s.incomeTransactionsTotal,
		// filterContract: s => s.filterContract,
		// contract: s => s.contract,
		incomeTransactionsLogs: s => s.incomeTransactionsLogs,
		incomeTransactionsLogsFilter: s => s.incomeTransactionsLogsFilter,
		incomeTransactionsCustomers: s => s.incomeTransactionsCustomers,
		incomeTransactionsRow: s => s.incomeTransactionsRow,

		paidTransactionsData: s => s.paidTransactionsData,
	}
};
